import type { WidgetLayout } from '@proadv/types';

/**
 * Layout default da pagina de financeiro. Grid 4 colunas x 3 linhas
 * conforme convencionado nas paginas home/clients (GRID_COLS=4, GRID_ROWS=3).
 *
 * Como o financeiro tem mais widgets do que slots no grid (9 widgets,
 * 12 slots), distribuimos assim por default — o usuario reordena no
 * modo edicao:
 *
 *   Linha 1 (y=0)  | summary_saldo | receita_prev | despesa_prev | atrasados |
 *   Linha 2 (y=1)  | chart_receita_despesa (2x2)  | contas (1x2) | top_desp (1x2) |
 *   Linha 3 (y=2)  | (chart continua)             | (contas)     | (top_desp)     |
 *
 * O `recent_transactions` e o `top_categorias_receita` ficam fora do
 * default e podem ser adicionados pelo usuario via menu "Adicionar widget".
 * Justificativa: GRID_ROWS=3 limita o layout default; mantemos os widgets
 * essenciais visiveis (KPIs + chart + contas + top despesa) e deixamos
 * "extras" como opt-in.
 */
export const FINANCIAL_DEFAULT_LAYOUT: WidgetLayout[] = [
  { widgetId: 'summary_saldo', x: 0, y: 0, w: 1, h: 1 },
  { widgetId: 'summary_receita_prevista', x: 1, y: 0, w: 1, h: 1 },
  { widgetId: 'summary_despesa_prevista', x: 2, y: 0, w: 1, h: 1 },
  { widgetId: 'summary_pagamentos_atrasados', x: 3, y: 0, w: 1, h: 1 },
  { widgetId: 'chart_receita_despesa', x: 0, y: 1, w: 2, h: 2 },
  { widgetId: 'contas_bancarias', x: 2, y: 1, w: 1, h: 2 },
  { widgetId: 'top_categorias_despesa', x: 3, y: 1, w: 1, h: 2 },
];
